import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'underscoreRemovePipe',
  standalone: true
})
export class UnderscoreRemovePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.replace(/_/g, ' ');
  }
}
